import hljs from 'highlight.js';
import fadeInDirective from './fadein';

export default function directive(app: any) {
  //   app.directive('loading', loadingDirective);
  app.directive('fadein', fadeInDirective);
  app.directive('highlight', (el) => {
    const blocks = el.querySelectorAll('pre code');
    blocks.forEach((block) => {
      hljs.highlightElement(block);
    });
  });
}
